const selectRequestStatus = state => state.app.status;

export default { selectRequestStatus };
